export default __webpack_public_path__ + "static/Dashlights-c83c6fd0b111e9560c59037d43a88f4e.svg";